"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLIUtils = void 0;
const path = __importStar(require("path"));
const StringSeparator_1 = require("../../enums/StringSeparator");
class CLIUtils {
    static getUserConfig(configPath) {
        const configFileExtension = path.extname(configPath);
        const isValidExtension = CLIUtils.allowedConfigFileExtensions.includes(configFileExtension);
        if (!isValidExtension) {
            throw new ReferenceError('Given config path must be a valid `.js`, `.cjs` or `.json` file path');
        }
        const errors = [];
        try {
            return require(configPath);
        }
        catch (error) {
            errors.push(error);
        }
        try {
            return __non_webpack_require__(configPath);
        }
        catch (error) {
            errors.push(error);
        }
        throw new ReferenceError(`Cannot open config file with path: ${configPath}. Reason: ${CLIUtils.getConfigErrorReason(errors)}`);
    }
    static stringifyOptionAvailableValues(optionEnum) {
        return Object.values(optionEnum).join(`${StringSeparator_1.StringSeparator.Comma} `);
    }
    static getConfigErrorReason(errors) {
        const [firstError, secondError] = errors;
        if (secondError && !secondError.message.includes('__non_webpack_require__')) {
            return secondError.message;
        }
        return firstError.message;
    }
}
exports.CLIUtils = CLIUtils;
CLIUtils.allowedConfigFileExtensions = ['.js', '.json', '.cjs'];
